export function generateLink(baseUrl, serial,redirectUrl, goalId = null) {
    let json = {
        serial: serial,
        redirect: redirectUrl
    };
    if (goalId) {
        json.goalId = goalId;
    }
    const base64 = btoa(JSON.stringify(json));
    const data = base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
    const url = new URL(baseUrl + data);
    return url.toString();
}